if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        document.body.dataset.quickAddActive = 'false';

        // const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        // if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        // this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        document.body.dataset.quickAddActive = 'true';

        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        if (opener.getAttribute('data-product-url')) {
            fetch(opener.getAttribute('data-product-url'))
                .then((response) => response.text())
                .then((responseText) => {
                    const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                    this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
                    this.productElement.classList.forEach((classApplied) => {
                    if (classApplied.startsWith('color-') || classApplied === 'gradient')
                        this.modalContent.classList.add(classApplied);
                    });
                    this.preventDuplicatedIDs();
                    this.removeDOMElements();
                    this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

                    if (window.Shopify && Shopify.PaymentButton) {
                    Shopify.PaymentButton.init();
                    }

                    if (window.ProductModel) window.ProductModel.loadShopifyXR();

                    this.removeGalleryListSemantic();
                    this.updateImageSizes();
                    this.preventVariantURLSwitching();
                    this.updateInputsOnVariantChange(opener);
                    this.activateLiveText();
                    super.show(opener);
                })
                .finally(() => {
                    opener.removeAttribute('aria-disabled');
                    opener.classList.remove('loading');
                    opener.querySelector('.loading__spinner').classList.add('hidden');
                });
        } else {
            setTimeout(() => {
                super.show(opener);
                opener.removeAttribute('aria-disabled');
                opener.classList.remove('loading');
                opener.querySelector('.loading__spinner').classList.add('hidden');
            }, 1000);
        
        }
        
      }

      // VG: listen for variant changes, and update input fields

      updateInputsOnVariantChange(opener) {
        const select = this.querySelector('[name="id"]');
        const customizer = this.querySelector(`#customizer`);

        if (select) {
            select.addEventListener('change', async () => {

                customizer.dataset.loading = 'true';

                await fetch(`${opener.getAttribute('data-product-url')}?variant=${select.value}`)
                    .then((response) => response.text())
                    .then((responseText) => {
                        const html = new DOMParser().parseFromString(responseText, 'text/html');
                        const sourceElement = html.querySelector('#customizer');
                        const targetElement = this.querySelector('#customizer');
    
                        if (targetElement && sourceElement) {
                            targetElement.innerHTML = sourceElement.innerHTML;
                        }

                        const sourceLiveText = html.querySelector('#customizer-live-text');
                        const targetLiveText = this.querySelector('#customizer-live-text');

                        if (targetLiveText && sourceLiveText) {
                            targetLiveText.innerHTML = sourceLiveText.innerHTML;
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    });
    
                this.activateLiveText();

                customizer.dataset.loading = 'false';
            });
        }
        
      }

      // VG: make live text dynamic based on inputs

      activateLiveText() {

        const addToCartButton = this.querySelector('[name="add"]');
        const nodes = this.querySelectorAll(`[customizer]`);

        nodes.forEach((node, index) => {

            const id = node.dataset.id
            const input = node.querySelector('[input]');
            const count = node.querySelector('[count]');
            const liveText = this.querySelector(`[live-text][data-id='${id}']`);

            if (this.dataset[`currentText${id}`] && this.dataset[`currentCharacterCount${id}`]) {
                input.value = this.dataset[`currentText${id}`];
                count.innerHTML = this.dataset[`currentCharacterCount${id}`]
            }
            
            input?.addEventListener('keyup', () => {
                updateInput();
            });

            const emojis = node.querySelectorAll('[data-emoji]');

            for (const emoji of emojis) {
                emoji.addEventListener('click', () => {
                input.value = input.value.concat(emoji.dataset.emoji);
                updateInput();
                });
            }

            const updateInput = () => {
                const maximumCharacters = count.dataset.count;
                const typedCharacters = input.value.length;
                const currentCharacterCount = maximumCharacters - typedCharacters;
                this.dataset[`currentCharacterCount${id}`] = currentCharacterCount;
                this.dataset[`currentText${id}`] = input.value;

                node.dataset.currentCharacterCount = currentCharacterCount;

                count.innerHTML = currentCharacterCount;
                
                liveText.innerHTML = input.value;

                let numberOfEmojisInInput = 0;
                let strRegex = new RegExp(/^[a-z0-9]+$/i);

                for (let i = 0; i < input.value.length; i++) {
                if (!strRegex.test(input.value[i])) numberOfEmojisInInput++;
                }

                node.dataset.numberOfEmojis = numberOfEmojisInInput

                toggleButton();
            }

            
            updateInput();

        });

        function toggleButton() {
          let hasTooManyCharacters = false

          for (const node of nodes) {

            if ((node.dataset.currentCharacterCount < 0) || (node.dataset.numberOfEmojis > 8)) {
              hasTooManyCharacters = true    
            }
          }

          if (hasTooManyCharacters) {
            addToCartButton.disabled = true
          } else {
            addToCartButton.disabled = false
          }
        }

        const radios = this.querySelectorAll('[customizer-live-text-toggle]');

        if (radios.length > 0) {
            document.body.dataset.customizerLiveText = '1';

            for (const radio of radios) {
                radio.addEventListener('change', (e) => {
                    document.body.dataset.customizerLiveText = e.target.value
                });
            }
        }

      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
